/**
 * @desc 根据父订单号查询相关的子订单号
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/omsflow/listByParentSoOrderNo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
